import React from 'react';
import { INIT } from '@jd/jmtd-group/es/jmtd-group';
import { Icon, Tooltip, Label, RadioGroup, RadioButtonGroup } from '@jd/jmtd';

export default function GeRealtimeGroup({ realtime, offline, defaultInRealtime = true }) {
    const fields = [];
    let hasSwitch = false;

    // 有切换按钮
    if (realtime && offline) {
        hasSwitch = true;
        fields.push({
            component: RadioGroup,
            name: 'inRealtime',
            trackLabel: '实时离线切换',
            props: {
                outline: true,
                render: RadioButtonGroup,
                data: [
                    {
                        label: <Label>近3日<Tooltip title={'支持选择近3天实时数据，可按照10分钟粒度进行勾选，最长时间跨度不超过48小时；默认展示今日0点至今的实时累计数据。'}>
                            <Icon className='jmti-question-circle' ></Icon>
                        </Tooltip></Label>,
                        value: true
                    },
                    {
                        label: '离线',
                        value: false
                    }
                ],
                value: defaultInRealtime
            }
        });
    }

    [
        {
            arg: realtime,
            name: 'realtime',
            inRealtime: true,
            trackLabel: '实时时间'
        },
        {
            arg: offline,
            name: 'offline',
            inRealtime: false,
            trackLabel: '离线时间'
        }
    ].forEach(({ arg, name, inRealtime, trackLabel }) => {
        if (arg) {
            const { reducer, ...other } = arg;
            fields.push({
                name,
                ...other,
                trackLabel,
                reducer({ setState, actionType, changedState, getProps, ...otherArg }) {
                    // 如果没有reducer，使用默认初始化
                    if (actionType === INIT && !reducer) {
                        setState({});
                    }

                    // 实时、离线切换
                    if (hasSwitch && (changedState.inRealtime || actionType === INIT)) {
                        setState({
                            visible: getProps('inRealtime')?.value === inRealtime
                        });
                    }

                    // 回调自定义reducer
                    if (reducer) {
                        reducer({
                            setState,
                            actionType,
                            changedState,
                            getProps,
                            ...otherArg
                        });
                    }
                }
            });
        }
    });

    return {
        className: 'jmtp-ge-realtime-group',
        common: true,
        fields
    };
}
